import { v4 as uuidv4 } from 'uuid'

/*
  Create an new unique GUID
  Each video Session ID is created when the user starts video using GUID
*/
export const generateUUID = (): string => {
  const uuid: string = uuidv4()
  return uuid
}
